import { Component, Input, ViewChild, ElementRef, Output, EventEmitter } from "@angular/core";
import { AbstractControl } from "@angular/forms";

@Component({
  selector: 'form-input-text-button',
  template: `
      <div class="w-100">
        <label class="font-weight-bold">{{label}}</label>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <button class="cursor-pointer input-group-text" type="button" (click)="onClickEvent()"><i [ngClass]="icon"></i></button>
          </div>
          <div class="custom-file">
            <input type="text" class="form-control" 
                          [class.is-invalid]="control.invalid && control.dirty" 
                          [placeholder]="placeholder" 
                          [formControl]="control"
                          (blur)="blur.emit($event)">
            <div *ngIf="control.invalid && control.dirty" class="text-danger-form">{{errorMsg ? errorMsg : 'campoObbligatorio' | translate}}</div>
          </div>
        </div>
      </div>
    `,
  styles: ['.cursor-pointer {cursor: pointer}']
})

export class FormInputTextButtonComponent {

  @ViewChild('inputUploadRef') inputUploadRef: ElementRef;

  @Input() control: AbstractControl;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() errorMsg: string;
  @Input() icon = 'fas fa-trash';


  @Input() isRequired: boolean;

  @Output() onClick: EventEmitter<void> = new EventEmitter();
  @Output() blur: EventEmitter<any> = new EventEmitter();

  onClickEvent() {
    this.onClick.emit();
  }
}
